module.exports = __webpack_public_path__ + "img/thumb_04.f8da83b4.jpg";